const de = {
  title: "Wunschliste",
  descriptionLines: [
    "Hier findest du alle Produkte, die du zu deiner Wunschliste hinzugefügt hast.",
    "Die Wunschliste ist nur auf diesem Gerät gespeichert.",
  ],
  addToWishlist: "Zur Wunschliste hinzufügen",
  removeFromWishlist: "Von Wunschliste entfernen",
}

const en: typeof de = {
  title: "Wishlist",
  descriptionLines: [
    "Here you can find all products you have added to your wishlist.",
    "The wishlist is only saved on this device.",
  ],
  addToWishlist: "Add to wishlist",
  removeFromWishlist: "Remove from wishlist",
}

export const wishlistText = { de, en }
